export const Footer = () => (
  <footer className="relative z-10 pb-14 pt-14">
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20">
      <div className="flex flex-col md:flex-row items-center md:items-center text-center md:text-left justify-between gap-6">
        <span className="font-mono-plex text-[15px] text-[#48606f]">
          Copyright © 2026 Catherine. All Rights Reserved.
        </span>
        {/* Made with Love by MaCaja — commented out per request
        <span className="font-mono-plex text-[15px] text-[#48606f]">
          Made with <span className="text-[#f5842a]">Love</span> by{" "}
          <a
            href="https://magawa.website/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#2fbf71] link-underline"
          >
            MaCaja
          </a>
        </span>
        */}
        <span className="font-mono-plex text-[14px] text-[#48606f] opacity-80 md:text-right">
          Catherine Magawa - Epidemiology & Biostatistics, Class of 2026
        </span>
      </div>
    </div>
  </footer>
);
